/**
 * @flow
 * @format
 */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cc from 'classcat';
import { Col, Table } from 'reactstrap';

import { getFieldValues } from '~/selectors/design';
import { HashId } from '~/utils';

// import log from '~/utils/macros/debug.macro';
import type { Connector } from 'react-redux';

import classes from './TableGroup.scss';

type OwnPropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string | null,
  error: string[],
  id: string,
  revertInput: Function,
  value: number | string | null,
};

type PropsType = {
  rowData: string[][],
  rowHeader: string[],
} & OwnPropsType;

const hashId = new HashId();

// eslint-disable-next-line react/prefer-stateless-function
export class TableGroup extends React.Component<PropsType, *> {
  static defaultProps = {
    rowHeader: [],
    rowData: [],
  };

  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    const tHeader = this.props.rowHeader.map(s => (
      <th key={hashId.nextId()}>{s || <span>&nbsp;</span>}</th>
    ));
    const tRows = this.props.rowData.map((r: string[], k: number) => {
      const id = r[0];
      return (
        <tr key={id} className={cc([classes.partRow])}>
          {r.map((d, l) => <td key={hashId.encode(`${k}${l}`)}>{d}</td>)}
        </tr>
      );
    });

    return (
      <Col>
        <Table responsive size="sm" className={classes.table}>
          <thead className="thead-inverse">
            <tr>{tHeader}</tr>
          </thead>
          <tbody>{tRows}</tbody>
        </Table>
      </Col>
    );
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): PropsType {
  const values = getFieldValues(state);
  const data = values[ownProps.id];

  // log(data);

  const tableData: string[][] = _.get(data, ['currentValue'], []);
  let headData = _.head(tableData);

  if (_.every(headData, s => s.length === 0)) {
    headData = [];
  }

  return {
    ...ownProps,
    rowData: _.tail(tableData),
    rowHeader: headData,
  };
}

const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default connector(TableGroup);



// WEBPACK FOOTER //
// ./src/components/TableGroup/TableGroup.js